module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-slash-fill-91fb2270.svg";